import { useDroppable } from '@dnd-kit/core';

const PickupDropZone = ({ pickup, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `pickup-drop-${pickup.id}`,
    data: {
      pickup,
    },
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        borderRadius: '4px',

        outline: isOver ? '2px solid #8a8a8a' : 'none',

        transition: '0.15s ease',
      }}
    >
      {children}
    </div>
  );
};

export default PickupDropZone;
